import { Box, Stack } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import SectionHeader from '../SectionHeader'
import StimulusPlayer from './StimulusPlayer'
import DominantStrip from './DominantStrip'
import EmotionTimeline from './EmotionTimeline'
import EmotionLegend from './EmotionLegend'
import KeyMoments from './KeyMoments'

/** The hero card: synchronized stimulus player + emotion timeline on the left,
 *  key moments on the right. */
export default function HeroPlayerTimeline() {
  const theme = useTheme()
  const c = theme.affexy.colors
  const { t } = useTranslation('results')

  return (
    <Box
      sx={{
        bgcolor: c.white,
        border: `1px solid ${c.ink08}`,
        borderRadius: '18px',
        p: 2.75,
      }}
    >
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 320px' }, gap: 2.75 }}>
        <Stack spacing={1.5}>
          <SectionHeader title={t('hero.title')} subtitle={t('hero.sub')} />
          <StimulusPlayer />
          <DominantStrip />
          <EmotionTimeline />
          <EmotionLegend />
        </Stack>
        <Stack spacing={1.5}>
          <SectionHeader title={t('hero.keyMoments')} />
          <KeyMoments />
        </Stack>
      </Box>
    </Box>
  )
}
